import { DetailZittingComponent } from './detail-zitting/detail-zitting.component';
import {Routes} from '@angular/router';

export const detailZittingRoutes : Routes = [
    
    { path: 'detailzitting/:zittingid', component: DetailZittingComponent },
    { path: 'detailzitting/:zittingid/:docid', component: DetailZittingComponent },
];
